import React from 'react';
import PropTypes from 'prop-types';
import { Group } from '@visx/group';
import { useTooltip } from '@visx/tooltip';
import TooltipWrapper from './TooltipWrapper'; // Adjust path to your wrapper

const HorizontalStackedBar = ({
  data,
  total,
  width = '100%',
  height = 32,
  TooltipContent = null,
}) => {
  const {
    tooltipOpen,
    tooltipLeft,
    tooltipTop,
    tooltipData,
    hideTooltip,
    showTooltip,
  } = useTooltip();

  if (!total || total === 0) return null;

  let accumulatedWidth = 0;

  const handleMouseMove = (event, item) => {
    // Using clientX/clientY works perfectly since your TooltipWrapper uses portal={true}
    showTooltip({
      tooltipData: item,
      tooltipLeft: event.clientX,
      tooltipTop: event.clientY,
    });
  };

  return (
    <div style={{ position: 'relative', width: '100%', height }}>
      <svg
        width={width}
        height={height}
        style={{ width: '100%', borderRadius: '8px' }}
        onMouseLeave={hideTooltip} // Placed on the SVG so it doesn't flicker when moving between rects
      >
        <Group>
          {data.map((item, index) => {
            const segmentWidthPercentage = (item.value / total) * 100;

            if (segmentWidthPercentage === 0) return null;

            const rect = (
              <rect
                key={item.id || index}
                x={`${accumulatedWidth}%`}
                y={0}
                width={`${segmentWidthPercentage}%`}
                height={height}
                fill={item.color}
                onMouseMove={(e) => handleMouseMove(e, item)}
                style={{ cursor: TooltipContent ? 'pointer' : 'default' }}
              />
            );

            accumulatedWidth += segmentWidthPercentage;
            return rect;
          })}
        </Group>
      </svg>

      {/* Render the Tooltip via Portal if data exists and is open */}
      {tooltipOpen && tooltipData && TooltipContent && (
        <TooltipWrapper
          open={tooltipOpen}
          data={tooltipData}
          tooltipPosition={{ top: tooltipTop, left: tooltipLeft }}
          portal={true}
        >
          <TooltipContent data={tooltipData} />
        </TooltipWrapper>
      )}
    </div>
  );
};

HorizontalStackedBar.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
      value: PropTypes.number.isRequired,
      color: PropTypes.string.isRequired,
    })
  ).isRequired,
  total: PropTypes.number.isRequired,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.number,
  TooltipContent: PropTypes.elementType,
};

export default HorizontalStackedBar;
